import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { PageTransition } from '../components/PageTransition';
const faqs = [{
  question: 'What is Non-Emergency Medical Transportation (NEMT)?',
  answer: 'NEMT is a transportation service provided to individuals who are not in an emergency situation but need assistance getting to and from medical appointments, dialysis, or other healthcare-related destinations.'
}, {
  question: 'How do I schedule a ride?',
  answer: "You can schedule a ride by calling our dispatch center at (555) 123-4567 or by using the 'Request a Ride' button on our homepage. We recommend booking at least 24-48 hours in advance."
}, {
  question: 'Do you provide wheelchair-accessible vehicles?',
  answer: 'Yes, our entire fleet is equipped with modern hydraulic lifts and securement systems to accommodate standard and bariatric wheelchairs safely.'
}, {
  question: 'Will the driver stay with me during my appointment?',
  answer: "Our standard service is door-to-door. However, we can arrange for 'wait and return' service or specialized bedside-to-bedside assistance upon request."
}, {
  question: 'What insurance providers do you work with?',
  answer: 'We work with a wide range of private insurance providers, Medicare, and Medicaid. Please contact our billing department to verify your specific coverage.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <PageTransition data-id="element-319">
      <section id="faq" className="py-20 lg:py-32 bg-white" data-id="element-320">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-321">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-322">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-light rounded-2xl text-brand-blue mb-6" data-id="element-323">
              <HelpCircle size={32} data-id="element-324" />
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-brand-blue mb-6" data-id="element-325">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-326">
              Find answers to common questions about our medical transportation
              services and how we can help you or your loved ones.
            </p>
          </motion.div>

          <div className="space-y-4" data-id="element-327">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="border border-gray-200 rounded-2xl overflow-hidden" data-id="element-328">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors focus-visible:ring-2 focus-visible:ring-brand-blue outline-none" aria-expanded={openIndex === index} aria-label={`Toggle answer for: ${faq.question}`} data-id="element-329">
                  <span className="text-lg font-bold text-brand-blue" data-id="element-330">
                    {faq.question}
                  </span>
                  {openIndex === index ? <ChevronUp className="text-brand-blue shrink-0" data-id="element-331" /> : <ChevronDown className="text-gray-400 shrink-0" data-id="element-332" />}
                </button>
                <AnimatePresence data-id="element-333">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-334">
                      <div className="p-6 pt-0 text-gray-700 leading-relaxed border-t border-gray-100 bg-gray-50/50" data-id="element-335">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </section>
    </PageTransition>;
}